// enum hostSiteKeyMap {
//   americastestkitchen = 'atk',
//   cookscountry = 'cco',
//   cooksillustrated = 'cio',
//   onlinecookingschool = 'school',
// }

// args: _next asPath. with domain consolidation we have to
// check if the the domain is inserted before the doc-type pathname i.e. 'recipes'
// remove it to keep the api call the same.
export function pathToType(path: string) {
  const [, pathname, nestedPath] = path.split('/');
  if (pathname === 'cookscountry' || pathname === 'cooksillustrated') {
    return nestedPath;
  }
  return pathname;
}

export function generateAffiliatesUrl(url: string, tag?: string) {
  if (url && url.includes('amazon.com')) {
    if (url.includes('?tag')) {
      return {
        isAmazon: true,
        ctaUrl: `${url.split('?tag')[0]}?tag=${tag}`,
      };
    } else {
      return {
        isAmazon: true,
        ctaUrl: `${url}?tag=${tag}`,
      };
    }
  }

  return {
    isAmazon: false,
    ctaUrl: url,
  };
}
